<template>
  <div class="pageStyle" @click="showCompanyNameList = false">
    <div v-show="!isEmpty">
      <div class="header">
        <div>请填写您信息</div>
        <div>信息提交后会有专员联系您</div>
      </div>
      <div class="content">
        <div class="input-form">
          <!-- 贷款类型 -->
          <div class="item">
            <div class="title">
              <span><s></s></span>
              <span>贷款类型</span>
            </div>
            <div class="input type">
              <van-radio-group v-model="form.type" direction="horizontal">
                <van-radio name="person" shape="square">个人</van-radio>
                <van-radio name="company" shape="square">企业</van-radio>
              </van-radio-group>
            </div>
          </div>
          <!-- 产品名称 -->
          <div class="item" v-show="form.productId">
            <div class="title">
              <span><s></s></span>
              <span>产品名称</span>
            </div>
            <div class="input">
              <van-field readonly v-model="productName" />
            </div>
          </div>

          <!-- 姓名 -->
          <div class="item">
            <div class="title">
              <span><s></s></span>
              <span>姓名</span>
            </div>
            <div class="input">
              <van-field v-model="form.applyName" placeholder="请填写姓名" />
            </div>
          </div>

          <!-- 联系方式 -->
          <div class="item phone">
            <div class="title">
              <span><s></s></span>
              <span>联系方式</span>
            </div>

            <div class="input">
              <van-field
                type="digit"
                v-model="form.phone"
                placeholder="请填写联系方式"
              />
            </div>
          </div>

          <!-- 企业名称 贷款类型为个贷时，不显示 -->
          <div class="item companyNameInput" v-if="form.type !== 'person'">
            <div class="title">
              <span><s></s></span>
              <span>企业名称</span>
            </div>
            <div class="input">
              <van-field
                v-model="form.companyName"
                @input="onCompanyNameChange"
                @clear="clearCompanyName"
                clearable
                placeholder="请填写企业名称"
              />
              <div class="companyNameList" v-show="showCompanyNameList">
                <span
                  @click="choiceCompanyName(item)"
                  v-for="(item, index) in companyNameList"
                  :key="index"
                  >{{ item }}</span
                >
              </div>
            </div>
          </div>
          <!-- 统一社会信用代码 -->
          <div class="item" v-if="form.type !== 'person'">
            <div class="title">
              <span><s></s></span>
              <span>统一社会信用代码</span>
            </div>

            <div class="input">
              <van-field
                v-model="form.creditCode"
                placeholder="请填写统一社会信用代码"
              />
            </div>
          </div>

          <!-- 企业开票金额（万） -->
          <div class="item" v-if="form.type !== 'person'">
            <div class="title">
              <span><s></s></span>
              <span>企业开票金额（万）</span>
            </div>

            <div class="input">
              <van-field
                type="number"
                v-model="form.invoiceAmt"
                placeholder="请填写企业开票金额（万）"
              />
            </div>
          </div>

          <!-- 企业纳税金额（万） -->
          <div class="item" v-if="form.type !== 'person'">
            <div class="title">
              <span><s></s></span>
              <span>企业纳税金额（万）</span>
            </div>

            <div class="input">
              <van-field
                type="number"
                v-model="form.taxAmt"
                placeholder="请填写企业纳税金额（万）"
              />
            </div>
          </div>

          <div class="item btn">
            <van-button :loading="submitLoading" @click="submit()"
              >提交</van-button
            >
          </div>
        </div>
        <div class="bg">
          <div></div>
        </div>
      </div>

      <div class="foot"></div>
    </div>
    <div v-show="isEmpty">
      <van-empty description="产品不存在" />
    </div>
    <!-- 选择城市弹窗 -->
    <van-popup v-model="selectArea" position="bottom">
      <van-area
        :columns-num="2"
        title="选择城市"
        :area-list="areaList"
        @confirm="confirmArea"
        @cancel="selectArea = !selectArea"
      />
    </van-popup>
  </div>
</template>

<script>
import { xcCompanySearch, xcCompanyInfo } from "@/api/xcCustomer";
import { areaList } from "@vant/area-data";
import { getWx } from "@/utils/wxJsSdk.js";

import { xcLeadInfo } from "@/api/applyPage.js";
import { xcProductDict } from "@/api/product.js";
import Vue from "vue";
import {
  Notify,
  Empty,
  Button,
  Field,
  Toast,
  Popup,
  Area,
  DatetimePicker,
  RadioGroup,
  Radio,
} from "vant";
import { getCurrentChannelInfo } from "@/api/login.js";
Vue.use(Button);
Vue.use(Field);
Vue.use(Empty);
Vue.use(Popup);
Vue.use(Area);
Vue.use(Toast);
Vue.use(DatetimePicker);
Vue.use(Radio);
Vue.use(RadioGroup);
export default {
  created() {
    document.title = "填写信息";
    // 判断是否有产品id
    this.getQuery();
    // 获取渠道信息
    this.getChannelInfo();
  },
  data() {
    return {
      form: {
        productId: "",
        companyName: "",
        applyName: "",
        phone: "",
        invoiceAmt: "",
        taxAmt: "",
        channelId: "",
        depName: "",
        creditCode: "",
        needCreditLine: "",
        area: "",
        intentionBank: "",
        type: "person",
      },
      // 产品名称 用于展示
      productName: "",
      // 提交的loading
      submitLoading: false,
      // 选择城市弹窗
      selectArea: false,
      // 选择城市 城市数据
      areaList,
      // 提示:产品不存在
      isEmpty: false,
      // 产品列表
      productList: [],
      // url携带参数
      queryMsg: {},
      // 是否显示企业名称列表
      showCompanyNameList: false,
      // 企业名称快捷选择区域
      companyNameList: [],
      bizType: "",
    };
  },
  methods: {
    onCompanyNameChange(e) {
      // 例如：珠海市香
      if (e.length > 3) {
        xcCompanySearch(e).then((res) => {
          if (res && res[0]) {
            this.companyNameList = res;
            this.showCompanyNameList = true;
          }
        });
      }
    },
    clearCompanyName() {
      this.showCompanyNameList = false;
      this.companyNameList = [];
    },
    // 获取渠道信息
    getChannelInfo() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中",
      });
      getCurrentChannelInfo()
        .then((ress) => {
          Toast.clear();
          this.form.applyName = ress.name;
          this.form.phone = ress.phone;
          this.form.depName = ress.depName;
          this.form.channelId = ress.id;
        })
        .catch((err) => {
          Toast.clear();
        });
    },
    // 获取产品列表
    getProductList() {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中",
      });
      xcProductDict()
        .then((res) => {
          this.productList = res;
          // 判断产品是否存在
          let o = this.productList.find((item) => {
            return item.id == this.queryMsg.productId;
          });
          // 产品存在 赋值
          if (o) {
            this.productName = o.productName;
            this.form.productId = o.id;
          }
          // 有产品id，但是产品不存在 提示不存在
          else {
            Toast.clear();
            this.isEmpty = true;
          }
        })
        .catch((err) => {
          Toast.clear();
          console.log("err", err);
        });
    },
    // 在企业名称列表里选择企业
    choiceCompanyName(e) {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });
      xcCompanyInfo(e)
        .then((res) => {
          this.form.creditCode = res.creditCode;
          this.form.companyName = res.name;
          console.log("res", res);
          Toast.clear();
        })
        .catch((err) => {
          Toast.clear();
          console.log("err", err);
        });
      // this.form.companyName = e;
      // this.showCompanyNameList = false;
    },
    // 确认城市 确认
    confirmArea(areas) {
      this.form.area = areas[1].name;
      this.selectArea = !this.selectArea;
    },
    getQuery() {
      this.queryMsg = this.$route.query;
      // 没有带产品id的话，则产品不存在
      if (this.queryMsg.productId) {
        this.getProductList();
      }
    },
    // 提交信息
    submit() {
      // 校验填写内容
      if (this.toCheck()) {
        if (this.form.type == "person") {
          delete this.form.companyName;
        }
        for (let key in this.form) {
          if (!this.form[key]) delete this.form[key];
        }
        this.submitLoading = true;
        xcLeadInfo(this.form)
          .then((res) => {
            this.submitLoading = false;
            this.form.companyName = "";
            this.form.taxAmt = "";
            this.form.applyName = "";
            this.form.invoiceAmt = "";
            this.form.type = "person";
            this.form.creditCode = "";
            this.form.needCreditLine = "";
            this.form.area = "";
            this.form.intentionBank = "";
            Toast.success("信息提交成功");
          })
          .catch((err) => {
            this.submitLoading = false;
            // Toast.fail("信息提交失败");
          });
      }
    },
    // 检查填写
    toCheck() {
      if (!this.form.type) {
        Notify({ type: "danger", message: "请选择贷款类型" });
        return false;
      }
      if (!this.form.applyName) {
        Notify({ type: "danger", message: "请填写姓名" });
        return false;
      }
      if (!this.form.phone) {
        Notify({ type: "danger", message: "请填写联系方式" });
        return false;
      }
      // 企业版
      if (this.form.type == "company") {
        if (!this.form.companyName) {
          Notify({ type: "danger", message: "请填写企业名称" });
          return false;
        }
        if (!this.form.creditCode) {
          Notify({ type: "danger", message: "请填写统一社会信用代码" });
          return false;
        }
      }

      return true;
    },
    getShareTxt() {
      let desc = "点击立即申请";
      let that = this;
      let url = window.location.href;
      getWx(this.depName).then((res) => {
        window.wx.updateAppMessageShareData({
          title: "车贷申请", // 分享标题
          desc: desc, // 分享描述
          link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl:
            "https://static.xchengtech.cn/4a6254f9d27042ddabb8c7d8c766b9bc.png", // 分享图标
          success: function (res) {
            console.log("res", res);
            //afterShare();
          },
        });
      });
    },
  },
};
</script>

<style scoped src="./index.css"></style>


// WEBPACK FOOTER //
// src/view/applyPage/leadInfo/leadInfo.vue